// extracted by mini-css-extract-plugin
export default {"oneclubPlusCard":"oneclubPlusCard-tpP9HJ","head":"head-JZiuYP","body":"body-Ot62Pi","limit":"limit-AWnjYe","title":"title-BqzbsO","process":"process-hztVy0","nan":"nan-CYPBt9"};